import styles from "./progress.module.scss";

interface iProps {
  value: number;
  max?: number;
}

function Progress({ value, max = 100 }: iProps): JSX.Element {
  return <progress id="file" value={value} max={max} className={styles.progress} />;
}

export default Progress;
